import { IDriver } from "models/driver";

interface IProps {
  data?: IDriver | undefined;
}

export default function FleetInfo({ data }: IProps) {
  return (
    <div
      className="w-full lg:w-1/2 bg-white rounded-lg p-6"
      style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
    >
      <div className="w-full">
        <h4 className="text-lg font-medium">Fleet Information</h4>
        <div className="w-full flex flex-wrap">
          <div className="flex flex-col">
            <table className="text-sm">
              <tbody>
                <tr className="mt-4">
                  <td className="font-bold min-w-36">Fleet Name</td>
                  <td className="min-w-36">{data?.fleet.fleet_model.name}</td>
                </tr>
                <tr className="mt-4">
                  <td className="font-bold min-w-36">Fleet Brand</td>
                  <td className="min-w-36">{data?.fleet.brand}</td>
                </tr>
                <tr className="mt-4">
                  <td className="font-bold min-w-36">Fleet Model</td>
                  <td className="min-w-36">{data?.fleet.model}</td>
                </tr>
                <tr className="mt-4">
                  <td className="font-bold min-w-36">Fleet Color</td>
                  <td className="min-w-36">{data?.fleet.color}</td>
                </tr>
                <tr className="mt-4">
                  <td className="font-bold min-w-36">Plate Number</td>
                  <td className="min-w-36">{data?.fleet.plate_number}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
